var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "40px",
    viewBox: "0 -960 960 960",
    width: "40px",
    fill: "#405CB0",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M425.48-327.7q.67-78.99 16.91-115.21 16.24-36.23 61.29-74.95 40.87-35.42 62-65.3 21.13-29.88 21.13-65.53 0-41.99-28.01-69.84-28.01-27.84-77.63-27.84-50 0-77.81 29.08-27.82 29.09-40.4 63.48l-99.89-43.32q23.02-64.73 78.76-109.38 55.74-44.65 139.3-44.65 104.09 0 160.24 58.28 56.15 58.27 56.15 140.43 0 51.86-20.91 91.4-20.91 39.55-66.57 82.42-48.2 45.17-58.61 70.12-10.4 24.95-10.91 80.81H425.48Zm55.65 255.19q-32.93 0-56.14-23.21t-23.21-56.1q0-32.88 23.2-56.14 23.2-23.25 56.17-23.25 32.98 0 56.23 23.25 23.26 23.26 23.26 56.14 0 32.89-23.29 56.1t-56.22 23.21Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/question-mark.f68faa0f3273613604f0aaa563c6e852.svg";
export { ForwardRef as ReactComponent };